import { AccountLikeDescriptor } from '@synapex/shared2/entities'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiQueryKey } from '../../query-key'
import { apiGoogleLogin, apiGoogleLogout } from '../api'

export const useGoogleAuth = (ald: AccountLikeDescriptor) =>
    useMutation({
        mutationFn: () => {
            const redirectUrl = `${window.location.origin}${window.location.pathname}`
            return apiGoogleLogin({ ...ald, redirectUrl })
        },
    })

export const useGoogleLogout = (ald: AccountLikeDescriptor) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => apiGoogleLogout(ald),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: apiQueryKey.googleUserInfo(),
            })
        },
    })
}
